export const CHANGE_NAME_OR_CAREER = 'CHANGE_NAME_OR_CAREER';

export const UpdateNameOrCareer = (value) => {
    return {
        type: CHANGE_NAME_OR_CAREER,
        payload: {
            value: value
        }
    }
}